import {
    Typography, Link
} from '@mui/material';

export default function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            <Link color="inherit" href="https://www.facebook.com/QQMusicStore/" target="_blank">
                <img variant="body2" alt='QQ Music Store' src="img\QQ_LOGO.PNG" style={{ width: '100px' }} />
            </Link> <br />
            {'Maintain by '}
            <Link color="inherit" href="https://www.facebook.com/QQMusicStore/" target="_blank">
                QQ Music Store
            </Link>{'.'}
        </Typography>);
}